export default "__VITE_ASSET__Bu68K0QS__"